import styled from "styled-components";

const ContentContainer = styled.div`
  
  background: #eee;
  margin: -20px 0 0;
  text-align: center;
  padding: 5px 20px 25px;
  h2 {
    font-weight: 700 !important;
    line-height: 150%;
    color: #008183 !important;
    font-size: 24px !important;
    text-align: center !important;
  }
  .the-content {
    width: 100%;
    max-width: 1200px;
    margin: auto;
    .carousel {
      padding-bottom: 35px;
      .control-dots {
        .dot {
          outline: 0;
          box-shadow: none;
          background: #d8d8d8;
          &.selected {
            background: ${(props) => props.theme.colors.primary.main}
          }
        }
      }
    }
    .slide {
      background: transparent;
      img {
        max-width: 100px;
      }
    }
    .content-desktop {
      display: flex;
      & > div {
        width: 100%;
        max-width: 275px;
        margin: 0 15px;
      }
    }

    h3 {
      color: #000;
      font-size: 18px;
      font-weight: 700;
    }
    img {
      width: 100px;
      height: 100px;
      margin-bottom: 15px;
    }
    p {
      font-size: 14px;
    }
  }
  .mobile {
    display: none;
  }
`;

export default ContentContainer;
